import { getTestIds } from "../../../utils/TestIds";
export const getTextFieldTestIds = () => getTestIds({
  deprecatedTestIds: {
    TextFieldTestIds: {
      root: testid => testid !== null && testid !== void 0 ? testid : '',
      input: testid => testid ? "".concat(testid, "-input") : '',
      label: testid => testid ? "".concat(testid, "-label") : '',
      placeholder: testid => testid ? "".concat(testid, "-placeholder") : '',
      backdrop: testid => testid ? "".concat(testid, "-backdrop") : '',
      helperText: testid => testid ? "".concat(testid, "-helper-text") : ''
    }
  }
});
export const {
  TextFieldTestIds,
  MobileTextFieldTID
} = getTextFieldTestIds();